import React, { useEffect, useState } from "react";
import axios from "axios";
import Watermark from "../components/Watermark";

const priorities = ["Low", "Medium", "High"];

function addBusinessDays(date, days) {
  let result = new Date(date);
  let added = 0;
  while (added < days) {
    result.setDate(result.getDate() + 1);
    // 0 = Sunday, 6 = Saturday
    if (result.getDay() !== 0 && result.getDay() !== 6) {
      added++;
    }
  }
  return result;
}

const EmployeeDashboard = () => {
  const [tasks, setTasks] = useState([]);
  const [newTask, setNewTask] = useState({
    title: "",
    description: "",
    priority: "Low",
    due_date: "",
  });
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("jwt") || localStorage.getItem("token");

  useEffect(() => {
    if (!token) {
      setMessage("Not authenticated — missing token");
      return;
    }
    fetchTasks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Fetch tasks assigned to this user
  // const fetchTasks = async () => {
  //   setLoading(true);
  //   try {
  //     const res = await axios.get(`${apiUrl}/tasks`, {
  //       headers: { Authorization: `Bearer ${token}` },
  //     });
  //     setTasks(res.data);
  //   } catch (err) {
  //     setMessage(err.response?.data?.error || "Error fetching tasks");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const fetchTasks = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${apiUrl}/tasks`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // sort by created_at desc (newest first). fallback to id desc if created_at missing
      const getTime = (t) => {
        if (t.created_at) return new Date(t.created_at).getTime();
        return t.id ? Number(t.id) : 0;
      };
      const sorted = (res.data || []).slice().sort((a, b) => getTime(b) - getTime(a));

      setTasks(sorted);
    } catch (err) {
      setMessage(err.response?.data?.error || "Error fetching tasks");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setNewTask({ ...newTask, [e.target.name]: e.target.value });
  }
  

  // Create new task
  const handleCreateTask = async (e) => {
    e.preventDefault();
    if (!newTask.title || !newTask.description) {
      return setMessage("Title and description required");
    }

    let due_date = newTask.due_date;
    if (!due_date) {
      let daysToAdd = 10; // default
      if (newTask.priority === "High") daysToAdd = 2;
      else if (newTask.priority === "Medium") daysToAdd = 5;
      // Calculate due date from today, skipping weekends
      due_date = addBusinessDays(new Date(), daysToAdd).toISOString().split("T")[0];
    }

    try {
      await axios.post(`${apiUrl}/tasks`, { ...newTask, due_date }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMessage("Task created successfully!");
      setNewTask({ title: "", description: "", priority: "Low", due_date: "" });
      fetchTasks(); // refresh tasks
    } catch (err) {
      setMessage(err.response?.data?.error || "Error creating task");
    }
  };

  const filteredTasks = tasks
    .filter((task) =>
      task.title.toLowerCase().includes(search.toLowerCase()) ||
      task.description.toLowerCase().includes(search.toLowerCase())
    )
    .filter((task) => (statusFilter ? task.status === statusFilter : true));

//   return (
//     <div style={{ maxWidth: 800, margin: "20px auto" }}>
//       <h2>Employee Dashboard</h2>
//       {message && <p style={{ color: "red" }}>{message}</p>}

//       {/* New Task Form */}
//       <div style={{ marginBottom: "20px", border: "1px solid #ccc", padding: "10px" }}>
//         <h3>Create New Task</h3>
//         <input
//           type="text"
//           placeholder="Title"
//           value={newTask.title}
//           onChange={(e) => setNewTask({ ...newTask, title: e.target.value })}
//           style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
//         />
//         <textarea
//           placeholder="Description"
//           value={newTask.description}
//           onChange={(e) => setNewTask({ ...newTask, description: e.target.value })}
//           style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
//         />
//         <select
//           value={newTask.priority}
//           onChange={(e) => setNewTask({ ...newTask, priority: e.target.value })}
//           style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
//         >
//           <option>High</option>
//           <option>Medium</option>
//           <option>Low</option>
//         </select>
//         <button onClick={handleCreateTask} style={{ width: "100%", padding: "8px" }}>
//           Create Task
//         </button>
//       </div>

//       {/* Task List */}
//       <div>
//         <h3>Your Tasks</h3>
//         {tasks.length === 0 ? (
//           <p>No tasks assigned yet.</p>
//         ) : (
//           <table style={{ width: "100%", borderCollapse: "collapse" }}>
//             <thead>
//               <tr>
//                 <th style={{ border: "1px solid #ccc", padding: "8px" }}>ID</th>
//                 <th style={{ border: "1px solid #ccc", padding: "8px" }}>Title</th>
//                 <th style={{ border: "1px solid #ccc", padding: "8px" }}>Description</th>
//                 <th style={{ border: "1px solid #ccc", padding: "8px" }}>Priority</th>
//                 <th style={{ border: "1px solid #ccc", padding: "8px" }}>Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               {tasks.map((task) => (
//                 <tr key={task.id}>
//                   <td style={{ border: "1px solid #ccc", padding: "8px" }}>{task.id}</td>
//                   <td style={{ border: "1px solid #ccc", padding: "8px" }}>{task.title}</td>
//                   <td style={{ border: "1px solid #ccc", padding: "8px" }}>{task.description}</td>
//                   <td style={{ border: "1px solid #ccc", padding: "8px" }}>{task.priority}</td>
//                   <td style={{ border: "1px solid #ccc", padding: "8px" }}>{task.status}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         )}
//       </div>
//     </div>
//   );
// };

return (
    <div className="flex min-h-screen text-black p-8 gap-8">
    <Watermark /> {/* Watermark Component */}
    {/* Left: Task Creation */}
      <div className="w-full max-w-md bg-white rounded-2xl p-8 shadow-lg flex flex-col">
        <h2 className="text-2xl font-bold mb-6" align="center">Create a New Task</h2>
        <form onSubmit={handleCreateTask} className="flex flex-col gap-4">
          <input
            name="title"
            value={newTask.title}
            onChange={handleChange}
            placeholder="Task Title"
            className="rounded-lg  text-black px-4 py-3 focus:outline-none focus:ring-2 focus:ring-neon-purple"
            required
          />
          <textarea
            name="description"
            value={newTask.description}
            onChange={handleChange}
            placeholder="Task Description"
            className="rounded-lg text-black px-4 py-3 focus:outline-none focus:ring-2 focus:ring-neon-cyan"
            rows={3}
            required
          />
          <div className="flex gap-4">
            <select
              name="priority"
              value={newTask.priority}
              onChange={handleChange}
              className="rounded-lg bg-white text-muted px-4 py-3 flex-1 focus:ring-2 focus:ring-neon-purple"
            >
              {priorities.map((p) => (
                <option key={p} value={p}>{p}</option>
              ))}
            </select>
            <input
              type="date"
              name="due_date"
              value={newTask.due_date}
              onChange={handleChange}
              className="rounded-lg bg-white text-muted px-4 py-3 flex-1 focus:ring-2 focus:ring-neon-cyan"
            />
          </div>
          <button
            type="submit"
            className="mt-4 py-3 rounded-lg bg-[#7AA33E] text-white font-semibold hover:bg-neon-lime transition"
          >
            Create Task
          </button>
        </form>
      </div>

      {/* Right: Task List */}
      <div className="flex-1 bg-white rounded-2xl p-8 shadow-lg flex flex-col">
        <div className="flex items-center gap-4 mb-6">
          <input
            type="text"
            placeholder="Search tasks..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="rounded-lg text-muted px-4 py-2 flex-1"
          />
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="rounded-lg bg-purple-300 text-black px-4 py-2"
          >
            <option value="">All Status</option>
            <option value="open">Open</option>
            <option value="in progress">In Progress</option>
            <option value="closed">Closed</option>
          </select>
        </div>
        <div className="overflow-y-auto scrollbar-thin scrollbar-thumb-gray-200 scrollbar-track-gray-100 flex-1" style={{ maxHeight: "70vh" }}>
          {loading ? (
            <div className="text-center py-8">Loading...</div>
          ) : filteredTasks.length === 0 ? (
            <div className="text-center py-8 text-muted">No tasks found.</div>
          ) : (
            <table className="w-full text-left">
              <thead>
                <tr className="text-muted text-sm">
                  <th className="py-2 px-2">ID</th>
                  <th className="py-2 px-2">Title</th>
                  <th className="py-2 px-2">Details</th>
                  <th className="py-2 px-2">Priority</th>
                  <th className="py-2 px-2">Due Date</th>
                  <th className="py-2 px-2">Status</th>
                </tr>
              </thead>
              <tbody>
                {filteredTasks.map((task) => (
                  <tr key={task.id} className="border-b border-[#23283a] hover:bg-gray-200 transition">
                    <td className="py-2 px-2">{task.id}</td>
                    <td className="py-2 px-2">{task.title}</td>
                    <td className="py-2 px-2">{task.description}</td>
                    <td className="py-2 px-2">
                      <span className={`px-2 py-1 rounded-lg text-xs font-bold
                        ${task.priority === "High" ? "bg-red-500/20 text-red-400" :
                          task.priority === "Medium" ? "bg-yellow-500/20 text-yellow-400" :
                          "bg-green-500/20 text-green-400"}`}>
                        {task.priority}
                      </span>
                    </td>
                    <td className="py-2 px-2">{task.due_date ? new Date(task.due_date).toLocaleDateString() : "-"}</td>
                    <td className="py-2 px-2 capitalize">{task.status || "Pending"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmployeeDashboard;
